import { Map, List } from 'immutable';
import StudentUnitQuizResult from './model';

import {
  FETCH_UNIT_QUIZ_RESULTS_SUCCESS,
} from './actions';

export default function unitQuizResultsReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_UNIT_QUIZ_RESULTS_SUCCESS:
      return addUnitQuizResultsToMap(state, action);
    default:
      return state;
  }
}

function addUnitQuizResultsToMap(state, { payload, groupId }) {
  let newState = state;
  newState = newState.set(groupId,
      new List(payload.map((result) => StudentUnitQuizResult.create(result))));
  return newState;
}



// WEBPACK FOOTER //
// ./data/UnitQuiz/reducer.js